<div class="app-head {{theme}}">
  <div class="common-back-btn-{{theme}} close-btn" (click)="return()" *ngIf="!isTencent && (isOpenClass==0&&headTitle!=='')|| (headTitle==''&&!isPC)"></div>
  <p class="title">{{headTitle}}</p>
  <div class="pc-back-btn" (click)="return()" *ngIf="isOpenClass==0&&headTitle==''&&isPC"></div>
</div>



// WEBPACK FOOTER //
// ./src/component/header/component.header.html